export default __webpack_public_path__ + "static/media/mazar-online.4a034e00.jpg";